/**
 *
 * @param {*} px 像素值 string/number
 */
export function pixelToRem(px) {
    if (isNaN(px) || px === 0) {
        return '0rem';
    }
    return `${+px / 16}rem`;
}
